import type { InboxThread } from "@tellescope/types-models";
import { DraftsAndSentItem, type DraftsAndSentItemProps } from "@tellescope/ui";
import { useTellescopeQueries, type TellescopeModelFromName } from "@tellescope/tanstack-query";
import { Link } from "react-router-dom";
import { buildMessagingThreadLink } from "../../../../../utils";
import { useUpdateEnduserInSidebar } from "../../../../../hooks";

export interface InboxThreadListSentItemProps
  extends Pick<
    DraftsAndSentItemProps<TellescopeModelFromName<"endusers">>,
    "title" | "timestamp" | "preview" | "channel" | "groupPosition"
  > {
  thread: InboxThread;
  enduserIds: string[];
  className?: string;
}

export const InboxThreadListSentItem = ({ thread, enduserIds, ...rest }: InboxThreadListSentItemProps) => {
  const endusersQuery = useTellescopeQueries({
    model: "endusers",
    method: "getOne",
    requests: enduserIds,
    combine: (results) =>
      results.reduce<TellescopeModelFromName<"endusers">[]>((acc, curr) => {
        if (curr.data) {
          acc.push(curr.data);
        }
        return acc;
      }, []),
  });
  const updateEnduserInSidebar = useUpdateEnduserInSidebar();
  const enduserId = endusersQuery?.[0]?.id;

  return (
    <DraftsAndSentItem
      key={thread.id}
      endusers={endusersQuery}
      {...rest}
      altComponent={Link}
      altComponentProps={{
        to: buildMessagingThreadLink({
          view: "inbox",
          channel: thread.type,
          threadId: thread.id,
        }),
      }}
      className="block"
      onClickCapture={() => {
        updateEnduserInSidebar(enduserId);
      }}
    />
  );
};
